import { App, User } from 'app/models';
import { AppsService, AuthService } from 'app/services';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AppsSetupDialogComponent } from './apps-setup-dialog/apps-setup-dialog.component';
import { AppsDialogComponent } from './apps-dialog/apps-dialog.component';

@Component({
  standalone: false,
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss']
})
export class AppsComponent implements OnInit, OnDestroy {
  @Input()
  app: App;
  @Input()
  user: User;

  apps: App[];
  appsList: App[];
  error: string;
  noRecordFound: boolean;
  message = 'No_Applications_Found';
  descDisplay: number= Number.parseInt(environment.descriptionDisplayLength,10);
  userAppManager: boolean;
  isInternal: boolean;
  refreshProgress: number[] = [];
  private readonly onDestroy$ = new Subject<void>();

  constructor(
    public _appsService: AppsService,
    private readonly _router: Router,
    public dialog: MatDialog,
    public _authservice: AuthService
  ) {}

  ngOnInit() {
    this._appsService.loading = true;
    this.getApps();
    this.checkUserAdminStatus();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  navigateToAddRoles(app) {
    const dialog = this.dialog.open(AppsDialogComponent, {
      disableClose: true,
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      width: '700px',
      data: {
        app
      }
    });
    dialog.afterClosed().subscribe(result => {});
  }

  getApps() {
    this._appsService.loading = true;
    this._appsService.apps$.pipe(takeUntil(this.onDestroy$)).subscribe(
      apps => {
        this._appsService.loading = false;
        if (apps) {
          this.noRecordFound = apps.length === 0;
          this.apps = apps;
          this.appsList = apps;
        } else {
          this.noRecordFound = true;
        }
      },
      err => {
        this._appsService.loading = false;
        this.error = err;
      }
    );
  }

  monitorSearch(search: string) {
    if (search.trim().length >= Number(environment.minimumSearchLength)) {
      this.apps = this.appsList.filter(a =>
        a['name'].toUpperCase().includes(search.toUpperCase().trim())
      );
      this.noRecordFound = this.apps.length === 0;
    } else {
      this.apps = this.appsList;
      this.noRecordFound = false;
    }
  }

  goToApp(): void {
    if (this.app) {
      if (this.app.isUserAdmin) {
        this._router.navigate(['apps', this.app.clientId]);
      }
    }
  }

  navigateToUserPage(app) {
    this._appsService.selectedApp = app;
    this._router.navigate(['apps', app.clientId]);
  }
  checkUserAdminStatus() {
    this._authservice
      .checkIsAppManager$()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(res => {
        this.userAppManager = res;
      });
  }
  descriptionDisplay(appName: string){
    if(appName.length > this.descDisplay){
      return appName.substring(0,appName.length-10).concat('...');
    }
    else{
      return appName;
    }
  }
  navigateToAppSetup(app) {
   const appSetupDialogRef = this.dialog.open(AppsSetupDialogComponent, {
           disableClose: true,
           width: '850px',
           height: '630px',
           autoFocus: false,
           data:{
            appId:app.clientId,
            appName:app.name
           }
         });
     appSetupDialogRef.afterClosed().subscribe(result => {
      if (result) {
        app.isUserAdmin=true;
        this._router.navigate(['apps', app.clientId]);
      }
    });
         
   
  }

  refreshAppStatus(app, index) {
    this.refreshProgress.push(index);
    this._appsService.isSetupRequired(app.clientId).subscribe({
      next: (isSetupRequired) => {
        app.isSetUpRequired = isSetupRequired;
        app.isRefreshRequired = false;
        this.refreshProgress = this.refreshProgress.filter(progressIndex => progressIndex !== index);
      },
      error: () => {
        this.refreshProgress = this.refreshProgress.filter(progressIndex => progressIndex !== index);
      }
    });
  }

  isAppRefreshInProgress(index) {
    return this.refreshProgress.includes(index);
  }

}
